import { createApi } from '@adv-frontend/modules-query';
import { createBaseQuery } from '@adv-frontend/modules-query';
import {
    getUpdateRelatedServicesUrl,
    UpdateRelatedServicesMethod,
    type UpdateRelatedServicesPathParameters,
    type UpdateRelatedServicesRequest,
    type UpdateRelatedServicesSearchParams,
} from '@/shared/api/openApi';
import type { OrderDto } from '@/shared/api/order';
import { request } from '@/shared/api/request';
import { upsertGetOrderQueryData } from './api';

type UpdateRelatedServicesRequestParams = UpdateRelatedServicesRequest &
    UpdateRelatedServicesSearchParams &
    UpdateRelatedServicesPathParameters;

const relatedServicesApi = createApi({
    name: 'entities/order/api/relatedServices',
    baseQuery: createBaseQuery(request),
    endpoints: (builder) => {
        return {
            UpdateOrderRelatedServices: builder.mutation<OrderDto, UpdateRelatedServicesRequestParams>({
                query: (payload) => {
                    return {
                        url: getUpdateRelatedServicesUrl(payload),
                        method: UpdateRelatedServicesMethod,
                        params: { signature: payload.signature },
                        body: {
                            enabled: payload.enabled,
                        },
                    };
                },
                transformResponse: (response: OrderDto, meta, arg) =>
                    upsertGetOrderQueryData(response, meta, {
                        order_id: arg.order_id,
                        signature: arg.signature,
                        store_slug: arg.store_slug,
                    }),
            }),
        };
    },
});

export const useUpdateOrderRelatedServicesMutation = relatedServicesApi.useUpdateOrderRelatedServicesMutation;
